module.exports = __webpack_public_path__ + "static/media/sinatra.f7820762.png";